import React from "react";
import useKiwiWidget from "customHooks/useKiwiWidget";
import { useLocation } from "react-router-dom";

// For conditional css load loading it lazy
const HideKiwiWidget = React.lazy(() => import("./HideKiwiWidget"));

const pagesToShowKiwiWidget = ["^/login$"];

const KiwiWidget = () => {
  const location = useLocation();
  const showInCurrentPage = pagesToShowKiwiWidget.some((string) =>
    new RegExp(string).test(location.pathname),
  );

  useKiwiWidget();

  if (showInCurrentPage) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }

  return <HideKiwiWidget />;
};

export default KiwiWidget;
